import { render, staticRenderFns } from "./DefaultCoverModal.vue?vue&type=template&id=0e5c4090&scoped=true&"
import script from "./DefaultCoverModal.vue?vue&type=script&lang=js&"
export * from "./DefaultCoverModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCoverModal.vue?vue&type=style&index=0&id=0e5c4090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c4090",
  null
  
)

export default component.exports